export default __webpack_public_path__ + "fa6c187b28b61b75c8e8d5bc6c6ede64.jpeg";